import axiosInstance, { bankInstance } from "../axiosInstance";
import * as API from "../url";

const org = localStorage.getItem("org");

export const getAccBalance = async () => {
  const res = await axiosInstance.get(
    `${API.ACC_BALANCE}?isOrg=${
      org === "false" ? "false" : org === null ? "false" : "true"
    }`
  );
  return res.data;
};

export const createPin = async (body) => {
  const res = await axiosInstance.post(API.CREATE_PIN, body);
  return res.data;
};

export const createBusiness = async (body) => {
  const res = await axiosInstance.post(API.CREATE_BUSINESS, body);
  return res.data;
};

export const createSign = async (body) => {
  const res = await axiosInstance.post(API.CREATE_SIGN, body);
  return res.data;
};

export const transfer = async (body) => {
  const res = await axiosInstance.post(API.TRANSFER, body);
  return res.data;
};

export const validateBank = async (query) => {
  const res = await bankInstance.get(
    API.VERIFY_ACC(query.recipient, query.code)
  );
  return res.data;
};

export const getBene = async () => {
  const res = await axiosInstance.get(API.GET_BENE);
  return res.data;
};

export const getSignatories = async ({ queryKey }) => {
  const [, signatory] = queryKey;
  const res = await axiosInstance.get(
    `${API.GET_SIGNATORIES}?isSignatory=${signatory}`
  );
  return res.data;
};

export const getUser = async () => {
  const res = await axiosInstance.get(API.GET_USER);
  return res.data;
};

export const getBankCode = async () => {
  const res = await bankInstance.get(API.BANK_CODE);
  return res.data;
};

export const getFlow = async () => {
  const res = await axiosInstance.get(
    `${API.GET_FLOW}?isOrg=${
      org === "false" ? "false" : org === null ? "false" : "true"
    }`
  );
  return res.data;
};
